import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const Container = styled.div`
    margin-bottom: 10px;
    height: 100%;
    background-color: #FFFFFF;
    border: 1px ;
    border-radius: 8px;
    display: flex;
    padding: 10px 18px 0px;
    width: 100%;
`;

export const ButtonHospitalArea = styled.div`
margin-right: 50px;

    button{
        background-color: transparent;
        color: ${() => theme.colorsNormal.orangeLink};
        border: none;
        font-size: ${theme.font.size16};
        text-decoration: underline;
    }

    button:hover{
        cursor: pointer; 
    }

`;

export const IconPosition = styled.div`
    display: flex;
    width: 24px;
    float: left;

`;

export const ButtonMap = styled.button`
  
`;

export const ButtonInfo = styled.button`
    
`;

export const styledDivModal = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    div {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    }

    span {
        color: #5B5B5F;
        letter-spacing: 0px;
        font: normal normal bold 16px/24px Oxygen;
    }

    p {
        letter-spacing: 0px;
        color: #5B5B5F;
        opacity: 1;  
        font: normal normal normal 16px/24px Oxygen;
    }
`;

export const DivInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`;

export const DivEndItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .hours{
        font: normal normal bold 18px/2px Oxygen;
        letter-spacing: 0px;
        color: #1A171B;
        opacity: 1;
        
    }
    
    .textSpan {
        font: normal normal bold 16px/2px Oxygen;
        letter-spacing: 0px;
        color: #5B5B5F;
        opacity: 1;
       
    }
`;

export const DivSpecialty = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    
    .textSpan {
        font: normal normal bold 16px/2px Oxygen;
        letter-spacing: 0px;
        color: #5B5B5F;
        opacity: 1;
        margin-bottom: 25px;
     
    }
`;
